export function projectsPage(): string {
  return `
    <div class="min-h-screen">
      <!-- Page Header -->
      <section class="container-wide py-16 sm:py-24" aria-labelledby="projects-heading">
        <div class="max-w-3xl anim-reveal">
          <span class="section-label">Portfolio</span>
          <h1 id="projects-heading" class="font-display font-extrabold text-display-xl mb-6" style="color: var(--text-primary)">
            Mes Projets
          </h1>
          <p class="font-body text-body-lg" style="color: var(--text-secondary)">
            Decouvrez une selection de mes realisations en UX/UI design
          </p>
        </div>
      </section>

      <div class="divider container-wide" role="separator"></div>

      <!-- Projects Grid -->
      <section class="container-wide py-16 sm:py-20" aria-label="Liste des projets">
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

          <!-- Project Card 1 - Dashboard de planification -->
          <a href="#/project/dashboard-planification" class="card block overflow-hidden group anim-reveal delay-1" aria-label="Projet dashboard de planification - Dashboard de planification annuelle">
            <div class="aspect-[4/3] overflow-hidden flex items-center justify-center" style="background-color: var(--bg-subtle);">
              <img src="${document.querySelector('[data-asset="plan-de-travail"]')?.getAttribute('src') || ''}"
                   alt=""
                   class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                   loading="lazy"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
            </div>
            <div class="p-6 sm:p-8">
              <h2 class="font-display font-bold text-display-md mb-3" style="color: var(--text-primary)">Dashboard de planification</h2>
              <p class="font-body text-body-md mb-5" style="color: var(--text-secondary)">
                Dashboard de planification annuelle des pesees avec automatisation hebdomadaire et suivi des ecarts.
              </p>
              <div class="flex flex-wrap gap-2 mb-5">
                <span class="tag">UX/UI Design</span>
                <span class="tag">Dashboard</span>
                <span class="tag">Planification</span>
              </div>
              <span class="font-body font-semibold text-body-sm inline-flex items-center gap-1 group-hover:gap-2 transition-all" style="color: var(--color-primary)">
                Voir le projet
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                </svg>
              </span>
            </div>
          </a>

          <!-- Project Card 2 - Plateforme de réservation -->
          <a href="#/project/plateforme-reservation" class="card block overflow-hidden group anim-reveal delay-2" aria-label="Projet plateforme de réservation - Plateforme de reservation agricole">
            <div class="aspect-[4/3] overflow-hidden flex items-center justify-center" style="background-color: var(--bg-subtle);">
              <img src="${document.querySelector('[data-asset="agrilib-accueil"]')?.getAttribute('src') || ''}"
                   alt=""
                   class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                   loading="lazy"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
            </div>
            <div class="p-6 sm:p-8">
              <h2 class="font-display font-bold text-display-md mb-3" style="color: var(--text-primary)">Plateforme de réservation</h2>
              <p class="font-body text-body-md mb-5" style="color: var(--text-secondary)">
                Plateforme de mise en relation et de reservation en ligne entre agriculteurs et prestataires.
              </p>
              <div class="flex flex-wrap gap-2 mb-5">
                <span class="tag">UX/UI Design</span>
                <span class="tag">Web App</span>
                <span class="tag">Marketplace</span>
              </div>
              <span class="font-body font-semibold text-body-sm inline-flex items-center gap-1 group-hover:gap-2 transition-all" style="color: var(--color-primary)">
                Voir le projet
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                </svg>
              </span>
            </div>
          </a>

          <!-- Project Card 3 - Site éditorial local -->
          <a href="#/project/site-editorial-local" class="card block overflow-hidden group anim-reveal delay-3" aria-label="Projet site éditorial local - Maquettes mobile">
            <div class="aspect-[4/3] overflow-hidden flex items-center justify-center" style="background-color: var(--bg-subtle);">
              <img src="${document.querySelector('[data-asset="saintnectaire-iphone"]')?.getAttribute('src') || ''}"
                   alt=""
                   class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                   loading="lazy"
                   onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
            </div>
            <div class="p-6 sm:p-8">
              <h2 class="font-display font-bold text-display-md mb-3" style="color: var(--text-primary)">Site éditorial local</h2>
              <p class="font-body text-body-md mb-5" style="color: var(--text-secondary)">
                Proposition graphique mobile pour un site éditorial local.
              </p>
              <div class="flex flex-wrap gap-2 mb-5">
                <span class="tag">UX/UI Design</span>
                <span class="tag">Mobile</span>
                <span class="tag">Maquettes</span>
              </div>
              <span class="font-body font-semibold text-body-sm inline-flex items-center gap-1 group-hover:gap-2 transition-all" style="color: var(--color-primary)">
                Voir le projet
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                </svg>
              </span>
            </div>
          </a>

          <!-- Coming Soon -->
          <div class="card flex flex-col items-center justify-center text-center p-8 sm:p-10 min-h-[24rem] anim-reveal delay-4" style="border-style: dashed;">
            <div class="w-14 h-14 rounded-2xl flex items-center justify-center mb-5" style="background-color: rgba(67, 56, 202, 0.06);">
              <svg class="w-7 h-7" style="color: var(--color-primary); opacity: 0.6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
              </svg>
            </div>
            <h2 class="font-display font-bold text-body-lg mb-3" style="color: var(--text-primary)">D'autres projets arrivent bientot</h2>
            <p class="font-body text-body-md max-w-xs" style="color: var(--text-secondary)">
              De nouveaux projets seront ajoutes prochainement pour enrichir mon portfolio.
            </p>
          </div>

        </div>
      </section>

      <!-- CTA Section -->
      <section class="py-20 sm:py-28" style="background-color: var(--bg-subtle);" aria-labelledby="projects-cta-heading">
        <div class="container-narrow text-center">
          <div class="anim-reveal">
            <span class="section-label">Collaboration</span>
            <h2 id="projects-cta-heading" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">
              Interesse par mon travail ?
            </h2>
            <p class="font-body text-body-lg mb-10 max-w-lg mx-auto" style="color: var(--text-secondary)">
              Je serais ravi de discuter de votre prochain projet
            </p>
            <a href="mailto:arthur.miconnet1@gmail.com" class="btn-primary">
              <span>Commencons un projet ensemble</span>
              <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </a>
          </div>
        </div>
      </section>
    </div>
  `;
}
